<template>
<div>

    <v-data-table :headers="headers" :items="items" hide-actions class="elevation-1">
        <template slot="items" slot-scope="{ item: { id, category, score, self, question, meanScore, diffSelfAndmeanScore, sdScore, frequency}, index }">
            <tr><td>{{id}}</td>
                <td>{{category}}</td>
                <td>{{question}}</td>
                <td>{{self}}</td>
                <td>{{meanScore}}</td>
                <td>{{diffSelfAndmeanScore}}</td>
                <td><ho-bar-chart class="chart1" :value="meanScore" :marker="self" :ops="ops" /></td>
                <td>{{sdScore}}</td>
                <td>
                    <bar-chart class="chart2" :values="frequency" :markers="self != undefined ? [self - 1] : []" />
                </td>
            </tr>
        </template>
    </v-data-table>
</div>
</template>
<script>
import BarChart from './bar_chart.vue'
import HoBarChart from './horizontal_bar_chart.vue'
import { mean, standardDeviation, max } from 'simple-statistics'
export default {
    components: {BarChart, HoBarChart},
    props: {
        values: {
            required: true
        },
        ops:{
            required: true
        }
    },
    data() {
        return {
            headers: [
                { text: 'No', value: 'id' },
                { text: '分類', value: 'question', sortable: false },
                { text: '質問', value: 'question', sortable: false },
                { text: '本人', value: 'self' },
                { text: '協力者平均', value: 'meanScore' },
                { text: '協力者平均-本人', value: 'diffSelfAndmeanScore' },
                { text: '協力者平均&本人', value: '', sortable: false },
                { text: '標準偏差', value: 'sdScore' },
                { text: '点数分布', value: '', sortable: false }],
            numOfOptions: this.ops.length
        }
    },
    computed: {
        items() {
           return this.values.map(v => {
               const avg = this.round(mean(v.score), 2)
               return({
                id:v.id,
                category: v.category,
                question: v.question,
                self: v.self,
                score: v.score,
                meanScore: avg,
                diffSelfAndmeanScore: this.round(avg - v.self, 2),
                sdScore: this.round(standardDeviation(v.score),2),
                frequency: this.frequency(v.score),
            })}

            )
        }
    },
    methods: {
        frequency(score) {
            let dist = Array(this.numOfOptions).fill(0)
            score.forEach((e) => dist[e - 1] = dist[e - 1] + 1)
            return dist
        },
        round(value, demical){
            const n = Math.pow(10, demical)
            return (Math.round(value * n)/n).toFixed(demical)
        }

    }
}
</script>
